import { render } from "./FloatingDropdown.vue?vue&type=template&id=22aa1111"
import script from "./FloatingDropdown.vue?vue&type=script&lang=js"
export * from "./FloatingDropdown.vue?vue&type=script&lang=js"

import "./FloatingDropdown.vue?vue&type=style&index=0&id=22aa1111&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__